<template>
  <div class="business_details">
    <el-card>
      <div class="business_details_top">
        <div class="business_details_top_left">
          <el-image :src="detailsData.companyKey" v-if="detailsData.companyKey" />
          <el-image :src="pro" v-else />
        </div>
        <div class="business_details_flex">
          <div class="business_details_flex_top">
            <div class="business_details_flex_top_ul">
              <div class="business_details_flex_top_ul_li business_details_flex_top_ul_li_flex">
                <p>{{ detailsData.companyFullName }}</p>
                <span class="no_cooperation" v-if="detailsData.cooperationStatus === '未合作'">{{
                  detailsData.cooperationStatus
                }}</span>
                <span
                  class="in_cooperation"
                  v-else-if="detailsData.cooperationStatus === '合作中'"
                  >{{ detailsData.cooperationStatus }}</span
                >
                <span
                  class="to_be_renewed"
                  v-else-if="detailsData.cooperationStatus === '待续约'"
                  >{{ detailsData.cooperationStatus }}</span
                >
              </div>
              <div class="business_details_flex_top_ul_li">
                法人：<i class="iconfont icon-jr-icon-man"></i>{{ detailsData.legalPerson }}
              </div>
              <div class="business_details_flex_top_ul_li">
                企业简称：<i class="iconfont icon-jr-icon-man"></i>{{ detailsData.companyName }}
              </div>
              <div class="business_details_flex_top_ul_li">
                官网：<i class="iconfont icon-jr-icon-information"></i
                >{{ detailsData.companyWebsite }}
              </div>
              <div class="business_details_flex_top_ul_li">
                电话：<i class="iconfont icon-jr-icon-phone"></i>{{ detailsData.companyTelephone }}
              </div>
              <div class="business_details_flex_top_ul_li">
                地址：<i class="iconfont icon-jr-icon-address"></i>{{ detailsData.companyAddress }}
              </div>
              <div class="business_details_flex_top_ul_li">
                邮箱：<i class="iconfont icon-jr-icon-letter"></i>{{ detailsData.companyEmail }}
              </div>
            </div>
            <div class="business_details_flex_top_edit">
              <p @click="editItem()">编辑</p>
              <i class="iconfont icon-jr-icon-modify"></i>
            </div>
          </div>
          <div class="business_details_flex_bottom">
            <p v-if="detailsData.companyBriefIntroduction">
              {{ detailsData.companyBriefIntroduction }}
            </p>
          </div>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="business_details_table">
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-Clock"></i><span>成立时间</span>
          <p>{{ detailsData.companyEstablishTime }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-Clock"></i><span>主要成员</span>
          <p>{{ detailsData.principleMembers }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-block"></i><span>所属行业</span>
          <p v-if="detailsData.listIndustry">{{ detailsData.listIndustry.join(',') }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-flag"></i><span>所在城市</span>
          <p>{{ detailsData.companyCountry }} - {{ detailsData.companyCity }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-Semicircle"></i><span>融资轮次</span>
          <p>{{ detailsData.companyFinancingRounds }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-curve"></i><span>企业规模</span>
          <p>{{ detailsData.enterpriseScale }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-label"></i><span>企业部门</span>
          <p>{{ detailsData.corporateSector }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-label"></i><span>荣誉标签</span>
          <p>{{ detailsData.honorLabel }}</p>
        </div>
        <div class="business_details_table_li">
          <i class="iconfont icon-jr-icon-label"></i><span>经营范围</span>
          <p>{{ detailsData.businessScope }}</p>
        </div>
        <el-upload action :http-request="uploadFile" ref="upload" :show-file-list="false">
          <div class="add_document">+新增文档</div>
        </el-upload>
        <div class="table_data">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ color: '#333333' }"
          >
            <!-- <el-table-column align="center" type="selection" width="100"> </el-table-column> -->
            <el-table-column align="center" width="100" label="序号">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>

            <el-table-column align="center" label="文档名称">
              <template slot-scope="scope">
                <div class="documents_name">{{ scope.row.documentName }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="文档类型" width="230">
              <template slot-scope="scope">{{ scope.row.date }}</template>
            </el-table-column> -->

            <el-table-column align="center" label="上传人">
              <template slot-scope="scope">{{ scope.row.createName }}</template>
            </el-table-column>

            <el-table-column align="center" label="上传时间" prop="上传时间" sortable="custom">
              <template slot-scope="scope">{{ scope.row.createTime }}</template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <div class="table_options">
                  <div class="examine" @click="clickExamine(scope.row)">查看</div>
                  <div>
                    <el-upload
                      class="upload-demo"
                      action
                      :http-request="uploadFileReplace"
                      ref="uploadReplace"
                      :show-file-list="false"
                    >
                      <div class="replace" @click="clickReplace(scope.row.id)">替换</div>
                    </el-upload>
                  </div>
                  <div class="remove_item" @click="clickRemoveItem(scope.row)">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="business_details_foot">
        <p>来源：{{ detailsData.source }}</p>
        <p>最近更新时间：{{ detailsData.updateTime }}</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getCompanyBYid,
  getArchivesCenter,
  updateArchivesCenter,
  deleteArchivesCenter,
  addSaveArchivesCenter,
} from '@/api/enterprise.js'
import { uploadFile, uploadAdmin } from '@/api/projectCenter.js'
import pro from '../../../../../static/images/pro.png'
export default {
  name: 'businessDetails',
  data() {
    return {
      pro,
      detailsData: {
        businessScope: '', //经营范围
        listCorporateSector: [], //企业部门集合
        corporateSector: '',
        listPrincipleMembers: [], //主要成员集合
        principleMembers: '',
        legalPerson: '', //法人
        companyAddress: '', //公司详细地址
        companyBriefIntroduction: '', //公司简介
        companyCity: '', //所属城市
        companyCode: '', //企业编号
        companyCountry: '', //所属国家
        companyEmail: '', //公开邮箱
        companyEstablishTime: '', //公司成立时间
        companyFinancingRounds: '', //公司当前融资轮次
        companyFullName: '', //公司全称
        companyKey: '', //公司logo完整路径
        companyLogo: '', //公司logo
        companyProvince: '', //所属省份
        companyTelephone: '', //公开电话
        companyWebsite: '', //公司官网网址
        cooperationStatus: '', //合作状态
        createName: '', //创建人名字
        createTime: '', //创建时间
        enterpriseScale: '', //企业规模
        honorLabel: '', //荣誉标签
        honorLabels: '', //
        listIndustry: [], //
        updateName: '', //修改人名字
        updateTime: '' //修改时间
      },
      tableData: [], //企业文档集合
      replaceId: null
    }
  },
  computed: {
    //companyCode查询单个
    companyCode() {
      return this.$route.query.companyCode
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
    // item() {
    //   return JSON.parse(this)
    // }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    this.search()
  },
  methods: {
    async search() {
      const { data: res } = await getCompanyBYid({ companyCode: this.companyCode })
      if (res.resultCode === 200) {
        this.detailsData = res.data
      }
      const { data: req } = await getArchivesCenter({ companyCode: this.companyCode })
      if (req.resultCode === 200) {
        this.tableData = req.data
      }
    },
    //编辑企业
    editItem() {
      this.$router.push({
        path: '/dataManagement/updateEnterprise',
        query: { enterpriseType: 1, companyCode: this.companyCode }
      })
    },
    // 上传时间
    initDay() {
      const date = new Date() // 得到当前时间
      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const dat = date.getDate() // 日
      const hour = date.getHours() // 时
      const minute = date.getMinutes() // 分
      const second = date.getSeconds() // 秒
      const hours = hour < 10 || hour === 0 ? '0' + hour : hour // 时
      const minutes = minute < 10 ? '0' + minute : minute // 分
      const seconds = second < 10 ? '0' + second : second // 秒
      return `${year}-${mont}-${dat} ${hours}:${minutes}:${seconds}`
    },
    // 上传文档
    async uploadFile(file) {
      //上传文件的需要formData类型;所以要转
      let form = new FormData()
      form.append('files', file.file)
      const { data: res } = await uploadAdmin(form)
      if (res.resultCode == 200) {
        let query = {
          createName: sessionStorage.getItem('userName'), // 上传人
          createTime: this.initDay(), // 上传时间
          documentName: res.data.fileAddr[0].split('-').slice(1).join('-'), // 文档名称
          documentUrl: res.data.fileLook[0], // 文档路径
          id: 0, // 主键
          companyCode: this.companyCode //  项目id
        }
        const { data: resS } = await addSaveArchivesCenter(query)
        if (resS.resultCode == 200) {
          this.$message.success('新增成功')
          this.search()
        }
      }
    },
    // 查看当前文档
    clickExamine(row) {
      window.open(row.documentUrl, '_blank')
    },
    // 替换文档
    async uploadFileReplace(file, id) {
      //上传文件的需要formData类型;所以要转
      let form = new FormData()
      form.append('files', file.file)
      const { data: res } = await uploadAdmin(form)
      if (res.resultCode == 200) {
        let query = {
          createName: sessionStorage.getItem('userName'), // 上传人
          createTime: this.initDay(), // 上传时间
          documentName: res.data.fileAddr[0].split('-').slice(1).join('-'), // 文档名称
          documentUrl: res.data.fileLook[0], // 文档路径
          id: this.replaceId, // 主键
          companyCode: this.companyCode //  项目id
        }
        const { data: resS } = await updateArchivesCenter(query)
        if (resS.resultCode == 200) {
          this.$message.success('替换成功')
          this.search()
        }
      }
    },
    // 替换文档按钮
    clickReplace(id) {
      this.replaceId = null
      this.replaceId = id
    },
    // 删除单个文档
    async clickRemoveItem(row) {
      let id = []
      id.push(row.id)
      const { data: res } = await deleteArchivesCenter(id)
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.business_details {
  width: 100%;
  overflow: auto;

  .business_details_top {
    display: flex;
    flex-direction: row;
    overflow: hidden;

    .business_details_top_left {
      width: 100px;
      height: 100px;
      margin-right: 30px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      /deep/.el-image__inner {
        max-width: 100%;
        max-height: 100%;
        display: block;
        border-radius: 4px;
      }
    }

    .business_details_flex {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .business_details_flex_top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        overflow: hidden;

        .business_details_flex_top_ul {
          overflow: hidden;
          flex: 1;

          .business_details_flex_top_ul_li_flex {
            display: flex;
            flex-direction: row;
            align-items: center;
            overflow: hidden;

            p {
              font-size: 18px;
              font-weight: 500;
              color: #333333;
            }

            span {
              margin-left: 80px;
              display: block;
            }

            .no_cooperation {
              box-sizing: border-box;
              padding: 2px 4px;
              border-radius: 4px;
              color: #ffb847;
              background-color: rgba(255, 184, 71, 0.2);
              border: 1px solid #ffb847;
            }

            .in_cooperation {
              box-sizing: border-box;
              padding: 2px 4px;
              border-radius: 4px;
              color: #17757a;
              background-color: rgba(23, 117, 122, 0.2);
              border: 1px solid #17757a;
            }

            .to_be_renewed {
              box-sizing: border-box;
              padding: 2px 4px;
              border-radius: 4px;
              color: #4d70fa;
              background-color: rgba(77, 112, 250, 0.2);
              border: 1px solid #4d70fa;
            }
          }

          .business_details_flex_top_ul_li {
            width: 50%;
            float: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            overflow: hidden;
            margin-bottom: 10px;
            box-sizing: border-box;
            padding: 0 20px 0 0;
            color: #000000;
            font-size: 16px;
            height: 30px;

            i {
              color: #17757a;
              font-size: 16px;
              margin-right: 8px;
            }
          }
        }

        .business_details_flex_top_edit {
          margin-left: 40px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          line-height: 20px;
          overflow: hidden;
          color: #17757a;
          font-size: 16px;
          cursor: pointer;

          i {
            color: #17757a;
            font-size: 16px;
            margin-left: 5px;
          }
        }
      }

      .business_details_flex_bottom {
        p {
          line-height: 1.5em;
          width: 100%;
          color: #000000;
          font-size: 14px;
          overflow: hidden;
          box-sizing: border-box;
          padding: 6px;
          background-color: #f7faf8;
        }
      }
    }
  }

  .business_details_table {
    width: 100%;
    overflow: hidden;

    .business_details_table_li {
      height: 56px;
      line-height: 56px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-bottom: 0.5px solid #e5e5e5;
      overflow: hidden;
      color: #000000;

      i {
        color: #17757a;
        font-size: 16px;
        margin-right: 8px;
      }

      span {
        display: block;
        margin-right: 40px;
        font-size: 14px;
      }

      p {
        font-size: 12px;
      }
    }
  }

  .business_details_foot {
    width: 100%;
    overflow: hidden;
    margin-top: 80px;

    p {
      color: #999999;
      font-size: 12px;
      margin-top: 4px;
      line-height: 1.5em;
    }
  }
}
.add_document {
  width: 89px;
  height: 36px;
  color: #fff;
  background-color: #17757a;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 22px;
  margin-top: 10px;
  cursor: pointer;
}
.table_data {
  background-color: #fff;
  padding: 0 49px 0 27px;
  .table_options {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 14px;
    .examine {
      color: #17757a;
      cursor: pointer;
    }
    .replace {
      color: #17757a;
      cursor: pointer;
    }
    .remove_item {
      cursor: pointer;
      color: #fa5050;
    }
  }
  .documents_name {
    color: #4a6aed;
    font-size: 14px;
  }
}
</style>
